import {colors} from 'common/src/themes/light/palette';
import {CampaignVersionData, CampaignVersionStatus} from '../campaigns.types';

function getVersionData(version: CampaignVersionData, isNewActivationFlow = false) {
  if (version.isPendingActivation) {
    return {
      status: CampaignVersionStatus.PendingActivation,
      color: colors.cl_color_dark_gray,
      isLocked: true,
    };
  }

  if (version.isActivated) {
    return {
      status: CampaignVersionStatus.Active,
      color: colors.cl_color_light_green,
      isLocked: true,
    };
  }

  if (version.isDraft) {
    return {
      status: CampaignVersionStatus.Draft,
      color: colors.cl_color_blue,
      isLocked: false,
    };
  }

  if (version.activationTime?.start) {
    return {
      status: CampaignVersionStatus.Deactivated,
      color: colors.cl_color_dark_gray,
      isLocked: true,
    };
  }

  return {
    status: isNewActivationFlow ? CampaignVersionStatus.Locked : CampaignVersionStatus.Saved,
    color: colors.cl_color_dark_gray,
    isLocked: true,
  };
}

export default getVersionData;
